module.exports = __webpack_public_path__ + "static/media/shield_ur.a27a7594.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shield_ur.svg
// module id = 184
// module chunks = 0